import { apiIdSchema } from '@/shared/schemas/ids.schema'
import { z } from 'zod'

export const beneficiaryAdmissionStatusSchema = z.enum(['validated', 'refused'])

export type BeneficiaryAdmissionStatus = z.infer<typeof beneficiaryAdmissionStatusSchema>

export const beneficiaryValidationStatusSchema = z.enum(['pending', 'validated', 'refused'])

export type BeneficiaryValidationStatus = z.infer<typeof beneficiaryValidationStatusSchema>

export const beneficiarySourceSchema = z.enum(['import', 'declared', 'admin'])

export const beneficiaryJustificatifStatusSchema = z.enum(['pending', 'approved', 'rejected', 'not_required'])

export const beneficiaryRowSchema = z.object({
  id: apiIdSchema,
  nom: z.string(),
  prenom: z.string(),
  date_naissance: z.string().nullable().optional(),
  relation: z.string(),
  relation_other: z.string().nullable().optional(),
  // Imported beneficiaries may be `refused`; such rows are not selectable as
  // reservation occupants (server-gated). Optional: absent is treated as validated.
  admission_status: beneficiaryAdmissionStatusSchema.optional(),
  // Points review state of a declared child; absent is treated as validated.
  validation_status: beneficiaryValidationStatusSchema.optional(),
  validation_reason: z.string().nullable().optional(),
  source: beneficiarySourceSchema.optional(),
  declared_at: z.string().nullable().optional(),
  is_locked: z.boolean().optional(),
  justificatif_status: beneficiaryJustificatifStatusSchema.nullable().optional(),
})

export const beneficiaryDeclarationSettingsSchema = z.object({
  declaration_enabled: z.boolean(),
  justificatif_enabled: z.boolean(),
  justificatif_required: z.boolean(),
  can_add_partner: z.boolean().optional().default(true),
  allowed_relations: z.array(z.string()).optional().default([]),
})

export const beneficiariesListResponseSchema = z.object({
  data: z.array(beneficiaryRowSchema),
  meta: beneficiaryDeclarationSettingsSchema.optional(),
})

export type BeneficiaryRow = z.infer<typeof beneficiaryRowSchema>
export type BeneficiaryDeclarationSettings = z.infer<typeof beneficiaryDeclarationSettingsSchema>
